module.exports = __webpack_public_path__ + "img/high_five.def03457.svg";